import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import ScenarioSelectionCharts from './ScenarioSelectionCharts/ScenarioSelectionCharts';

const ScenarioSelectionChartsPicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.charts.name]: <ScenarioSelectionCharts relationship={resource.relationship(fr.relationships.charts.name)} />,
  }, null);
};

ScenarioSelectionChartsPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
ScenarioSelectionChartsPicker.defaultProps = {
};

export default ScenarioSelectionChartsPicker;
